module.exports = __webpack_public_path__ + "media/10.7dafbff6.mp3";